import React from "react";
import mobleman from "../../../assets/img/icons/mobleman.svg";
import ref from "../../../assets/img/icons/refigrator.svg";
import tv from "../../../assets/img/icons/tv.svg";
import light from "../../../assets/img/icons/light.svg";
import wc from "../../../assets/img/icons/wc.svg";
import bathroom from "../../../assets/img/icons/bathroom.svg";
import bed from "../../../assets/img/icons/bed.svg";
import cooler from "../../../assets/img/icons/cooler.svg";
import iraniannwc from "../../../assets/img/icons/iranianwc.svg";
import seshvar from "../../../assets/img/icons/seshvar.svg";
import otoo from "../../../assets/img/icons/otoo.svg";
import food from "../../../assets/img/icons/food.svg";
import arrow from "../../../assets/img/icons/arrow-left-green.svg";
import Button from "../../shared/Button";
const PlaceFeature = ({
  inforesidencedetail
}) => {
  return (
   <div className="mb-[40px]">
       <h5 className="text-[20px] font-[700] text-[#12171C] mb-[16px] mt-[40px]">
            امکانات اقامتگاه :
          </h5>
      <div className="py-[40px] grid grid-cols-3 PlaceFeature">
     {inforesidencedetail.facilities.map(i=> <div key={i.id} className="flex items-center">
        <div className="w-[38px] ml-[21px]">
          {/* <img src={i.name === "fireplace" ?mobleman:} alt="fearnitur" /> */}
        </div>
        <p className="text-[18px] text-[#292D32] font-[500]">{i.title}</p>
      </div>)
      }
     
    </div>
    {inforesidencedetail.facilities.legnth > 15 && <Button varient="outlined" >
      <div className="flex items-center">
      <p className="ml-[12px]">مشاهده همه امکانات</p>

        <img src={arrow}/>
      </div>
    </Button>}
   </div>
  );
};

export default PlaceFeature;
